export const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-script';
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
export const RECAPTCHA_TYPE = process.env.REACT_APP_RECAPTCHA_TYPE || 'v2_checkbox';
export const RECAPTCHA_ACTION = process.env.REACT_APP_RECAPTCHA_ACTION || 'contact_submit';
export const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || '/api/contactUs';
export const CAPTCHA_CONFIG_ERROR =
	'reCAPTCHA is not configured yet. Add REACT_APP_RECAPTCHA_SITE_KEY to the frontend environment.';

export const initialFormData = {
	name: '',
	email: '',
	phone: '',
	message: '',
	serviceType: '',
};

const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
const allowedFileExtensions = ['.jpg', '.jpeg', '.png', '.pdf'];

function getFileExtension(fileName = '') {
	const lastDotIndex = fileName.lastIndexOf('.');

	if (lastDotIndex === -1) {
		return '';
	}

	return fileName.slice(lastDotIndex).toLowerCase();
}

function isAllowedUpload(file) {
	if (!file) {
		return false;
	}

	const extension = getFileExtension(file.name);
	const hasAllowedExtension = allowedFileExtensions.includes(extension);
	const hasAllowedType = !file.type || allowedFileTypes.includes(file.type);

	return hasAllowedExtension && hasAllowedType;
}

export function validateForm(values, options = {}) {
	const { compact = false, requiresFiles = false, files = {} } = options;
	const nextErrors = {};
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const phonePattern = /^[0-9+()\-\s]{7,20}$/;

	if (values.name.trim().length < 2) {
		nextErrors.name = 'Enter your full name.';
	}

	if (!emailPattern.test(values.email.trim())) {
		nextErrors.email = 'Enter a valid email address.';
	}

	if (!phonePattern.test(values.phone.trim())) {
		nextErrors.phone = 'Enter a valid phone number.';
	}

	if (!compact && values.message.trim().length < 10) {
		nextErrors.message = 'Message must be at least 10 characters.';
	}

	if (compact && !values.serviceType.trim()) {
		nextErrors.serviceType = 'Select a service before submitting your request.';
	}

	if (requiresFiles) {
		const nicFront = files.nicFront;
		const nicBack = files.nicBack;

		if (!nicFront) {
			nextErrors.nicFront = 'Upload the NIC front copy.';
		} else if (!isAllowedUpload(nicFront)) {
			nextErrors.nicFront = 'NIC front copy must be a JPG, PNG, or PDF file.';
		}

		if (!nicBack) {
			nextErrors.nicBack = 'Upload the NIC back copy.';
		} else if (!isAllowedUpload(nicBack)) {
			nextErrors.nicBack = 'NIC back copy must be a JPG, PNG, or PDF file.';
		}
	}

	return nextErrors;
}